import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MatDialogRef, MAT_DIALOG_DATA, PageEvent, MatPaginator } from '@angular/material';


@Component({
  selector: 'app-lista-gestao-desconto',
  templateUrl: './lista-gestao-desconto.component.html',
  styleUrls: ['./lista-gestao-desconto.component.scss']
})
export class ListaGestaoDescontoComponent implements OnInit {
  public config: PerfectScrollbarConfigInterface = {};
  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  lista = [];

  constructor(    
    private dialogRef: MatDialogRef<ListaGestaoDescontoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.lista = data.lista;
  }

  ngOnInit(): void {
  }

  fechar(confirmar: boolean) {
    this.dialogRef.close(confirmar);
  }

}
